export default class stringUtilities {
    static CStr2(vText) {

        if (vText == null)
            return '';
        else
            return vText.toString();

    };

    static IsNumeric(vText) {

        vText = this.CStr2(vText).replace(/,/g, ''); // remove commas

        // http://stackoverflow.com/questions/18082/validate-numbers-in-javascript-isnumeric/1830844#1830844
        // jQuery also has the ff code
        return !isNaN(parseFloat(vText)) && isFinite(vText);
    };

    static CDec2(vText, vRemoveDecimals) {
        // PARAMS:
        //  vRemoveDecimals: optional

        vText = this.CStr2(vText).replace(/,/g, ''); // remove commas
        vText = vText.trim();

        if (this.IsNumeric(vText))
            if (this.CBool(vRemoveDecimals))
                return parseInt(vText);
            else
                return parseFloat(vText);
        else if (/^\([^()]+\)$/.test(vText)) {
            vText = vText.replace(/\(/, '');
            vText = vText.replace(/\)/, '');
            vText = vText.trim();
            return -this.CDec2(vText, vRemoveDecimals);
        } else if (vText.toLowerCase() == 'true')
            return 1;
        else
            return 0;

    }; // END CDec2

    static CInt2(vText) {

        return this.CDec2(vText, true);

    }

    static CBool(vText) {

        if (vText == undefined) return false;
        if (this.CDec2(vText) != 0) return true;
        if (this.CStr2(vText).trim().toLowerCase() == 'true') return true;

        return false;

    };

    static FormatDate(vDate) {
        if (vDate == null)
            return '';
        else
            return new Date(vDate).toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
            });
    }

    static isoDateWithoutTimeZone(date) {
        // https://stackoverflow.com/a/69399448/334045
        if (date == null) return date;
        if (!(date instanceof Date))
            date = new Date(date);
        var timestamp = date.getTime() - date.getTimezoneOffset() * 60000;
        var correctDate = new Date(timestamp);
        // correctDate.setUTCHours(0, 0, 0, 0); // uncomment this if you want to remove the time
        return correctDate.toISOString();
    }
}